import React, { forwardRef } from 'react';
import { styled } from '@compiled/react';
import type { PopupComponentProps } from '@atlaskit/popup';
import { colors } from '@atlaskit/theme';
import { layers } from '@atlaskit/theme/constants';
import { token } from '@atlaskit/tokens';

const PopupComponent = forwardRef<HTMLDivElement, PopupComponentProps>((props, ref) => (
	<PopupComponentContainer {...props} ref={ref} />
));

export default PopupComponent;

// Workaround for https://github.com/atlassian-labs/compiled/issues/1200
const layerValue = layers.modal;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PopupComponentContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('elevation.surface.overlay', colors.N0),
	borderRadius: token('border.radius.100', '3px'),
	boxShadow: token(
		'elevation.shadow.overlay',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		`0 4px 8px -2px ${colors.N50A}, 0 0 1px ${colors.N60A}`,
	),
	boxSizing: 'border-box',
	display: 'block',
	flex: '1 1 auto',
	overflow: 'visible',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: layerValue() + 1,
	'&:focus': {
		outline: 'none',
	},
	minWidth: '240px',
});
